import {Dispatch, SetStateAction} from 'react'
import {v4} from 'uuid'
import {BaseRequestResult} from './request'

export const createAction =
  <P>(type: string) =>
  (payload?: P, setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>) => ({
    type,
    payload,
    setRequestResult,
  })

export interface RequestResult {
  requestType: string
  success: boolean
  result: BaseRequestResult
}

export interface CreateDoRequestActionInput<P> {
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
  payload: P
  disableLoadingState?: boolean
}

export interface CreateDoRequestActionOutput<P> {
  type: string
  payload: P & {requestId: string}
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
  disableLoadingState?: boolean
}

export type RequestAction<P> = (input: CreateDoRequestActionInput<P>) => CreateDoRequestActionOutput<P>

export const createDoRequestAction =
  <P extends Record<string, any> = Record<string, any>>(type: string): RequestAction<P> =>
  ({setRequestResult, payload, disableLoadingState}) => {
    const requestId: string = v4()
    return {
      type,
      payload: {
        ...payload,
        requestId,
      },
      setRequestResult,
      disableLoadingState,
    }
  }
